// PRODUCT PAGE COLOR SWATCHES SCRIPT START //
document.addEventListener("DOMContentLoaded", function() {
  var colorLinks = document.querySelectorAll('.product-colors a');
  colorLinks.forEach(function(link) {
    link.addEventListener('mouseenter', function() {
      var colorName = this.getAttribute('data-color');
      document.querySelector('.product-current-color').textContent = colorName;
    });
    link.addEventListener('mouseleave', function() {
      var currentColor = document.querySelector('.product-current-color').getAttribute('data-product-current-color-value');
      document.querySelector('.product-current-color').textContent = currentColor;
    });
  });
});
// PRODUCT PAGE COLOR SWATCHES SCRIPT END //
document.addEventListener("click", function (event) {
    if (event.target.closest(".collection_description.before span")) {
        let beforeElement = event.target.closest(".collection_description.before");
        beforeElement.style.display = "none";
        let afterElement = beforeElement.nextElementSibling;
        if (afterElement && afterElement.classList.contains("collection_description") && afterElement.classList.contains("after")) {
            afterElement.style.display = "block";
        }
    }

    if (event.target.closest(".collection_description.after span")) {
        let afterElement = event.target.closest(".collection_description.after");
        afterElement.style.display = "none";
        let beforeElement = afterElement.previousElementSibling;
        if (beforeElement && beforeElement.classList.contains("collection_description") && beforeElement.classList.contains("before")) {
            beforeElement.style.display = "block";
        }
    }
});
// Attach event listener to document to handle clicks on '.cdk-product-box .read_more'
document.addEventListener('click', function(event) {
    // Check if the clicked element has the class 'read_more'
    if (event.target.matches('.cdk-product-box .read_more')) {

        // Get the closest '.cdk-product-box' ancestor of the clicked element
        var productBox = event.target.closest('.cdk-product-box');

        // Hide the '.half_text' element within the '.cdk-product-box'
        var halfText = productBox.querySelector('.half_text');
        if (halfText) halfText.style.display = 'none';

        // Show the '.full_text' element within the '.cdk-product-box'
        var fullText = productBox.querySelector('.full_text');
        if (fullText) fullText.style.display = 'block';

        // Hide the clicked '.read_more' element
        event.target.style.display = 'none';

        // Show the '.read_less' element within the '.cdk-product-box'
        var readLess = productBox.querySelector('.read_less');
        if (readLess) readLess.style.display = 'inline-block';
    }
});


document.addEventListener('click', function(event) {
    if (event.target.matches('.cdk-product-box .read_less')) {
        var productBox = event.target.closest('.cdk-product-box');
        
        // Show the '.half_text' element
        var halfText = productBox.querySelector('.half_text');
        if (halfText) halfText.style.display = '-webkit-box';
        
        // Hide the '.full_text' element
        var fullText = productBox.querySelector('.full_text');
        if (fullText) fullText.style.display = 'none';
        
        // Hide the '.read_less' button
        event.target.style.display = 'none';
        
        // Show the '.read_more' button
        var readMore = productBox.querySelector('.read_more');
        if (readMore) readMore.style.display = 'inline-block';
    }
});

// Search drawer input focus on icon click

document.addEventListener('click', function(event) {
 if (event.target.closest('.search__icon--summary')) {
   setTimeout(() => {
     const searchInput = document.querySelector('.search-drawer .search-input');
     
     if (searchInput) {
       const clickEvent = new MouseEvent('click', {
         view: window,
         bubbles: true,
         cancelable: true
       });
       
       searchInput.dispatchEvent(clickEvent);
       searchInput.focus();
     }
   }, 500);
 }
});

document.addEventListener('DOMContentLoaded', function () {
    // Attach the click event to the document for delegation
    document.addEventListener('click', function (event) {
        // Check if the clicked element is a custom localized switcher
        const switcher = event.target.closest('.custom_loaclized_switcher_main');
        let disclosureList;

        if (switcher) {
            // Get the next sibling of the clicked switcher
            disclosureList = switcher.nextElementSibling;

            // Remove the 'hidden' attribute from the corresponding .disclosure__list-wrapper
            if (disclosureList && disclosureList.classList.contains('disclosure__list-wrapper')) {
                disclosureList.removeAttribute('hidden');
            }
        } else {
            // Close all disclosure lists if the click is outside them
            document.querySelectorAll('.disclosure__list-wrapper').forEach((list) => {
                list.setAttribute('hidden', 'hidden');
            });
        }
    });
});